import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'dayjs/locale/pt-br';

import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';

import {
    LoginPage,
    DashboardPage,
    PlansPage,
    PlanGroupsPage,
    ApplicationServicesPage,
    AccessKeysPage,
    UserManagementPage
} from '../pages';
import { acSetDarkMode } from '../store/actions';
import { ROUTES } from '../store/constants';
import { LightTheme, DarkTheme } from '../theme';

function App() {

    const dispatch = useDispatch()

    const darkMode = useSelector(state => state.auth.darkMode)

    useEffect(() => {
        dispatch(acSetDarkMode(false))
        // eslint-disable-next-line
    }, [])

    return (
        <ThemeProvider theme={darkMode ? DarkTheme : LightTheme}>
            <CssBaseline />
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='pt-br'
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
            >
                <BrowserRouter>
                    <Routes>

                        { /* UNPROTECTED ROUTES */}
                        <Route path={ROUTES.LOGIN} Component={LoginPage} />

                        { /* PROTECTED ROUTES */}
                        <Route path={ROUTES.DASHBOARD} Component={DashboardPage} />
                        <Route path={ROUTES.PLANS} Component={PlansPage} />
                        <Route path={ROUTES.PLAN_GROUPS} Component={PlanGroupsPage} />
                        <Route path={ROUTES.APPLICATION_SERVICES} Component={ApplicationServicesPage} />
                        <Route path={ROUTES.ACCESS_KEYS} Component={AccessKeysPage} />
                        <Route path={ROUTES.USERS} Component={UserManagementPage} />

                        { /* ANY OTHER ROUTE FALLS HERE */}
                        <Route path="*" Component={LoginPage} />

                    </Routes>
                </BrowserRouter>
            </LocalizationProvider>
        </ThemeProvider>
    )
}

export default App
